import React from "react";
import { PAGE_SIZE, STATUS_BADGE } from "./leaveShared";

// Leave rows with their actions, and paging below

const ActionButton = ({ onClick, primary, children }) => (
  <button
    onClick={onClick}
    className={
      primary
        ? "text-white bg-blue-600 hover:bg-blue-700 px-3 py-1 rounded shadow-sm text-xs transition"
        : "text-gray-700 bg-white border hover:bg-gray-100 px-3 py-1 rounded shadow-sm text-xs transition"
    }
  >
    {children}
  </button>
);

const LeaveRow = ({ leave, onReview, onHistory, onEdit, onBreakdown }) => (
  <tr className="border-b hover:bg-gray-50 transition">
    <td className="py-3 px-4">
      <div className="font-medium text-gray-800">{leave.employee?.fullName}</div>
      <div className="text-xs text-gray-500">{leave.employee?.contactNumber}</div>
    </td>
    <td className="py-3 px-4">
      {leave.startDate} <br />
      to {leave.endDate}
    </td>
    <td className="py-3 px-4">
      {leave.leaveMode.replace(/_/g, " ")} <br />
      <span className="text-xs text-gray-500">{leave.leaveType}</span>
      {leave.hasDocument ? (
        <a
          href={leave.documentUrl}
          target="_blank"
          rel="noreferrer"
          className="block text-xs text-blue-600 underline"
        >
          View document
        </a>
      ) : (
        leave.documentRequired && (
          <span className="block text-xs text-amber-700">Document missing</span>
        )
      )}
    </td>
    <td className="py-3 px-4 max-w-xs truncate" title={leave.reason}>
      {leave.reason}
    </td>
    <td className="py-3 px-4">
      <span
        className={`px-2 py-1 rounded text-xs font-semibold ${
          STATUS_BADGE[leave.status] || "bg-gray-100 text-gray-800"
        }`}
      >
        {leave.status}
      </span>
      {leave.autoAbsent && (
        <div className="text-[11px] text-gray-500 mt-1" title="No Mark present and no leave that day">
          auto · not marked present
        </div>
      )}
      {leave.adminRemark && (
        <div className="text-xs text-gray-500 mt-1" title={leave.adminRemark}>
          Remark: {leave.adminRemark}
        </div>
      )}
      {(leave.status === "APPROVED" || leave.status === "ABSENT") && leave.penaltyAmount > 0 && (
        <div
          className="mt-1 text-xs font-bold text-red-600 cursor-pointer hover:underline"
          onClick={() => onBreakdown(leave)}
        >
          Penalty: ₹{leave.penaltyAmount}
        </div>
      )}
      {leave.status === "PENDING" && leave.projectedPenaltyAmount != null && (
        <div
          className="mt-1 text-xs font-medium text-orange-500 cursor-pointer hover:underline"
          onClick={() => onBreakdown(leave)}
        >
          Projected: ₹{leave.projectedPenaltyAmount}
        </div>
      )}
    </td>
    <td className="py-3 px-4 space-x-2">
      {leave.status === "PENDING" && (
        <ActionButton primary onClick={() => onReview(leave)}>
          Review
        </ActionButton>
      )}
      <ActionButton onClick={() => onHistory(leave)}>History</ActionButton>
      {!["REJECTED", "CANCELLED"].includes(leave.status) && (
        <ActionButton onClick={() => onEdit(leave)}>Edit</ActionButton>
      )}
    </td>
  </tr>
);

const LeaveTable = ({ leaves, total, page, onPage, ...actions }) => (
  <>
    <div className="overflow-x-auto">
      <table className="min-w-full text-left text-sm text-gray-600">
        <thead className="bg-gray-100 text-gray-700">
          <tr>
            <th className="py-3 px-4 rounded-tl-lg">Employee</th>
            <th className="py-3 px-4">Dates</th>
            <th className="py-3 px-4">Mode & Type</th>
            <th className="py-3 px-4">Reason</th>
            <th className="py-3 px-4">Status</th>
            <th className="py-3 px-4 rounded-tr-lg">Actions</th>
          </tr>
        </thead>
        <tbody>
          {leaves.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center py-4">
                No leave requests found.
              </td>
            </tr>
          ) : (
            leaves.map((leave) => <LeaveRow key={leave.id} leave={leave} {...actions} />)
          )}
        </tbody>
      </table>
    </div>
    {total > PAGE_SIZE && (
      <div className="flex items-center justify-between mt-4 text-sm text-gray-600">
        <span>
          Showing {page * PAGE_SIZE + 1}–{Math.min((page + 1) * PAGE_SIZE, total)} of {total}
        </span>
        <div className="space-x-2">
          <button
            disabled={page === 0}
            onClick={() => onPage(page - 1)}
            className="px-3 py-1 border rounded bg-white hover:bg-gray-100 disabled:opacity-40"
          >
            Previous
          </button>
          <button
            disabled={(page + 1) * PAGE_SIZE >= total}
            onClick={() => onPage(page + 1)}
            className="px-3 py-1 border rounded bg-white hover:bg-gray-100 disabled:opacity-40"
          >
            Next
          </button>
        </div>
      </div>
    )}
  </>
);

export default LeaveTable;
